import type { IconData } from '@stacksjs/iconify-core'

export const internetNetworkDownload: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.955 25.9h1.52v3.05h-1.52Zm-1.52-3.04h1.52v3.04h-1.52Zm-24.38 6.09v1.53h1.52V32h22.86v-1.52h1.52v-1.53zm18.28-19.81h4.57v1.53h-4.57Zm-7.62 16.76h4.57v1.53h-4.57Zm0-22.85h4.57v1.52h-4.57Zm0-3.05h4.57v1.52h-4.57Zm0 13.71h-3.05v1.53h1.53v1.52h1.52v1.52h1.53v1.53h1.52v-1.53h1.52v-1.52h1.53v-1.52h1.52v-1.53h-3.05V6.09h-4.57zm-7.62-4.57h4.57v1.53h-4.57Z\"/><path fill=\"currentColor\" d=\"M27.435 22.86V10.67h-1.53v10.66H6.095V10.67h-1.52v12.19zm-24.38 0h1.52v3.04h-1.52Zm-1.53 3.04h1.53v3.05h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default internetNetworkDownload
